import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

import Input from "shared/components/FormElements/Input";
import CustomSelect from "shared/components/FormElements/Select";
import DatePicker from "shared/components/FormElements/DatePicker";
import FormFooter from "shared/components/FormElements/FormFooter";
import LoadingSpinner from "shared/components/UIElements/LoadingSpinner";
import { transfertypes } from "shared/util/types";
import { VALIDATOR_REQUIRE } from "shared/util/validators";
import { useForm } from "shared/hooks/form-hook";
import { useHttpClient } from "shared/hooks/http-hook";
import { AuthContext } from "shared/context/auth-context";
import { StoreContext } from "shared/context/store-context";
import { CheckTimeString } from "shared/util/time";

const TransferNew = () => {
  const { t } = useTranslation();
  const auth = useContext(AuthContext);
  const store = useContext(StoreContext);

  const { isLoading, sendRequest } = useHttpClient();

  const APIEndPoint = "transfers";

  const itemSubmitHandler = async (event) => {
    event.preventDefault();

    if (!CheckTimeString(formState.inputs.transfertime.value)) {
      window.toast.error(t("transferNew.timeFormatError"));
      return;
    }

    try {
      const responseData = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/${APIEndPoint}`,
        "POST",
        JSON.stringify({
          name: formState.inputs.name.value,
          type: formState.inputs.type.value,
          school: formState.inputs.school.value,
          transferdate: formState.inputs.transferdate.value,
          transfertime: formState.inputs.transfertime.value,
          done: formState.inputs.done.value,
          vehicleRoutes: [],
        }),
        {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth.token,
        },
      );

      if (responseData?.transfer) {
        store.InsertTransfer(responseData.transfer);
      }
      window.toast.success(t("transferNew.createSuccess"));
    } catch (err) {
      if (err?.message) {
        window.toast.error(err.message);
      } else {
        window.toast.error(t("actionFailed"));
      }
    }
  };

  const [formState, inputHandler] = useForm(
    {
      school: { value: "", isValid: false },
      name: { value: "", isValid: false },
      type: { value: "", isValid: false },
      transferdate: { value: "", isValid: false },
      transfertime: { value: "", isValid: false },
      done: { value: false, isValid: true },
      vehicleRoutes: { value: [], isValid: true },
    },
    false,
  );

  return (
    <React.Fragment>
      <form
        className="vertical-flex"
        style={{
          padding: "24px 32px",
          gap: "12px",
          maxWidth: "700px",
          maxHeight: "500px",
          margin: "0px",
        }}
        onSubmit={itemSubmitHandler}
      >
        {isLoading && <LoadingSpinner asOverlay />}

        <CustomSelect
          options={store.schoolOptions}
          id="school"
          onInput={inputHandler}
          label={t("client") + " *"}
          validators={[VALIDATOR_REQUIRE()]}
        ></CustomSelect>

        <CustomSelect
          options={transfertypes}
          id="type"
          onInput={inputHandler}
          label={t("transferNew.type") + " *"}
        ></CustomSelect>

        <Input
          id="name"
          element="input"
          type="text"
          label={t("transferNew.name") + " *"}
          validators={[VALIDATOR_REQUIRE()]}
          errorText={t("transferNew.nameError")}
          onInput={inputHandler}
        />

        <div className="horizontal-flex">
          <DatePicker
            id="transferdate"
            onInput={inputHandler}
            label={t("transferNew.date") + " *"}
            validators={[VALIDATOR_REQUIRE()]}
          ></DatePicker>

          <div style={{ maxWidth: "300px" }}>
            <Input
              id="transfertime"
              element="input"
              type="text"
              label={t("transferNew.time") + " *"}
              validators={[VALIDATOR_REQUIRE()]}
              errorText={t("transferNew.timeError")}
              onInput={inputHandler}
            />
          </div>
        </div>

        <FormFooter
          isNewItem={true}
          onUpdate={itemSubmitHandler}
          isUpdating={isLoading}
          disabled={!formState.isValid || isLoading}
          cta={t("transferNew.createButton")}
        />
      </form>
    </React.Fragment>
  );
};

export default TransferNew;
